import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'xp-wait-download-dialog',
  templateUrl: './wait-download-dialog.component.html',
  styleUrls: ['./wait-download-dialog.component.scss']
})
export class WaitDownloadDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WaitDownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

}
